import Vue from 'vue'
import SimplebarVue from 'simplebar-vue'

Vue.component('Simplebar', SimplebarVue)
